export default __webpack_public_path__ + "static/media/available-funds.ef81fcb5.svg";